import VueI18n from 'vue-i18n'

const languages = [
  'cs',
  'el',
  'en-US',
  'es',
  'et',
  'fr',
  'hi',
  'ja-JP',
  'nl',
  'pt',
  'ro',
  'ru',
  'sk',
  'vi',
  'zh-CN',
  'zh-TW'
];

let messages = {};

for (let i = 0; i < languages.length; i++) {
  messages[languages[i]] = require(`./translations/${languages[i]}.json`);
}

export default {
  init: function(Vue) {
    Vue.use(VueI18n);
    return new VueI18n({
      locale: 'en-US',
      messages: messages
    })
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/i18n/index.js